import { TArrayQuestion } from "../../../interfaces/quiz";
import img1 from "../../../../img/gallery/historia_palacio/1.png";
import img2 from "../../../../img/quiz/img1.png";
import img3 from "../../../../img/quiz/img2.png";
import img4 from "../../../../img/quiz/img3.png";
import img5 from "../../../../img/quiz/img4.png";

const ptQuestions:TArrayQuestion =[
    {
        theme:"Constituição",
        question:"A sessão legislativa tem a duração de:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Quatro anos"
            },
            {
                ansCode:1,
                text:"Cinco anos"
            },
            {
                ansCode:2,
                text:"Dez anos"
            }
        ],
        correct:1
    },
    {
        theme:"Constituição",
        question:"Pode Assistir as reuniões plenárias da Sala de Sessões:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Qualquer cidadão"
            },
            {
                ansCode:1,
                text:"Apenas os cidadãos ou indivíduos convidados"
            },
            {
                ansCode:2,
                text:"Apenas os jornalistas e funcionários parlamentares"
            }
        ],
        correct:0
    },
    {
        theme:"Constituição",
        question:"O Presidente da Assembleia Nacional é eleito:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Por sufragio directo e universal nas eleições legislativas"
            },
            {
                ansCode:1,
                text:"Pelo tribunal constitucional"
            },
            {
                ansCode:2,
                text:"Por maioria absoluta dos votos dos Deputados em efectividade de funções"
            }
        ],
        correct:2
    },
    {
        theme:"Constituição",
        question:"A actual constituição foi aprovada em:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1990"
            },
            {
                ansCode:2,
                text:"1992"
            }
        ],
        correct:2
    },
    {
        theme:"Constituição",
        question:"A aprovação de duas moções de censura ao Governo, implica obrigatoriamente:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"A realização de eleições antecipadas"
            },
            {
                ansCode:1,
                text:"A demissão do Governo"
            },
            {
                ansCode:2,
                text:"A apresentação pelo Governo de uma moção de confiança"
            }
        ],
        correct:1
    },
    {
        theme:"Constituição",
        question:"A partir de que idade um cidadão pode candidatar-se a Presidente da Republica?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"18 anos"
            },
            {
                ansCode:1,
                text:"35 anos"
            },
            {
                ansCode:2,
                text:"45 anos"
            }
        ],
        correct:1
    },
    {
        theme:"História Parlamentar",
        question:"Em que ano se realizaram as primeiras eleições pluripartidárias em Cabo Verde?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1981"
            },
            {
                ansCode:2,
                text:"1991"
            }
        ],
        correct:2
    },
    {
        theme:"História Parlamentar",
        question:"Quem foi o primeiro Presidente da Assembleia Nacional?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Abílio Duarte"
            },
            {
                ansCode:1,
                text:"Amilcar Spencer Lopes"
            },
            {
                ansCode:2,
                text:"Antonio do Espirito Santo Fonseca"
            }
        ],
        correct:0
    },
    {
        theme:"História Parlamentar",
        question:"Qual foi a data da inauguração do Palácio da Assembleia Nacional?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"8 Outubro de 1988"
            },
            {
                ansCode:1,
                text:"18 Outubro de 1983"
            },
            {
                ansCode:2,
                text:"28 Outubro de 1985"
            }
        ],
        correct:2
    },
    {
        theme:"Parlamento em Imagens",
        question:"Em 1975 foi realizada neste edifício a primeira sessão Parlamentar. Consegue identificar o edifício?",
        image:{
            exist:true,
            src:img1
        },
        answer:[
            {
                ansCode:0,
                text:"Paços do Conselho - São Vicente"
            },
            {
                ansCode:1,
                text:"Paços do Concelho - Praia"
            },
            {
                ansCode:2,
                text:"Paços do Concelho - São Filipe"
            }
        ],
        correct:1
    },
    /*{
        theme:"Parlamento em Imagens",
        question:"De quem é a autoria do seguinte quadro, oferecido ao presidente da Assembleia Nacional em 1998?",
        image:{
            exist:true,
            src:img2
        },
        answer:[
            {
                ansCode:0,
                text:"Bertina Lopes"
            },
            {
                ansCode:1,
                text:"Kiki Lima"
            },
            {
                ansCode:2,
                text:"Pedro Martins"
            }
        ],
        correct:0
    },*/
    {
        theme:"Parlamento em Imagens",
        question:"Como se intitula esta pintura feita por vários artistas cabo-verdianos para comemoração do 20˚ aniversário da independência Nacional?",
        image:{
            exist:true,
            src:img3
        },
        answer:[
            {
                ansCode:0,
                text:"A Mistura crioula"
            },
            {
                ansCode:1,
                text:"O Cotidiano caboverdiano"
            },
            {
                ansCode:2,
                text:"A Aventura crioula"
            }
        ],
        correct:2
    },
    {
        theme:"Constituição",
        question:"À Assembleia Nacional de Cabo Verde é o segundo órgão de soberania nacional, a ela cabe as funções",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Legislativa e de fiscalização política"
            },
            {
                ansCode:1,
                text:"Vetar ou promulgar leis"
            },
            {
                ansCode:2,
                text:"Executiva"
            }
        ],
        correct:0
    },
    {
        theme:"Simbolos Nacionais",
        question:"O Hino atual de Cabo Verde foi escrito por",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Norberto Tavares"
            },
            {
                ansCode:1,
                text:"Amílcar Spencer Lopes "
            },
            {
                ansCode:2,
                text:"Abílio Duarte"
            }
        ],
        correct:1
    },
    {
        theme:"Parlamento em Imagens",
        question:"Qual o nome da figura do folclore cabo-verdiano representado nesta peça?",
        image:{
            exist:true,
            src:img4
        },
        answer:[
            {
                ansCode:0,
                text:"Chibinho"
            },
            {
                ansCode:1,
                text:"Tia Ganga"
            },
            {
                ansCode:2,
                text:"Blimundo"
            }
        ],
        correct:2
    },
    {
        theme:"Parlamento em Imagens",
        question:"Este monumento representa a amizade de Cabo Verde com que país?",
        image:{
            exist:true,
            src:img5
        },
        answer:[
            {
                ansCode:0,
                text:"Brasil"
            },
            {
                ansCode:1,
                text:"China"
            },
            {
                ansCode:2,
                text:"Portugal"
            }
        ],
        correct:1
    },
    {
        theme:"Constituição",
        question:"Cada Sessão Legislativa é encerada com um debate sobre um tema muito conhecido, qual é?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Estado da Nação"
            },
            {
                ansCode:1,
                text:"Orçamento de Estado"
            },
            {
                ansCode:2,
                text:"Estado da Justiça"
            }
        ],
        correct:0
    },
    {
        theme:"Constituição",
        question:"Nos termos do Regimento, quantas Sessões Ordinárias são realizadas a cada mês?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Uma"
            },
            {
                ansCode:1,
                text:"Duas"
            },
            {
                ansCode:2,
                text:"Três"
            }
        ],
        correct:1
    }

];

export default ptQuestions;